import React from 'react';
import { Row } from 'antd';
import { Colors, LineHeight } from '@common/tokens';

import { Column } from './_column';

export const HeaderBar = ({
  background,
  children,
}: React.PropsWithChildren<{ background?: string }>) => {
  const backgroundClass = background
    ? `bg-${background}`
    : 'bg-elm-hyper-hyperlight';

  return (
    <React.Fragment>
      <div className={`wk-header-bar ${backgroundClass}`}>
        <Row gutter={24} justify="space-between">
          {children}
        </Row>
      </div>
      <style jsx>{`
        .wk-header-bar {
          height: 72px;
          padding: 12px 24px;
          line-height: ${LineHeight.lg};
          color: ${Colors.steelHyperdark} !important;
        }
        .wk-header-bar :global(.ant-col + .ant-col) {
          border-left: 1px solid ${Colors.steel};
        }
      `}</style>
    </React.Fragment>
  );
};

HeaderBar.Column = Column;
